import * as React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { MyAccountService } from "./myaccount-service";
import { dialogService } from "react-api-dialog";
import t from "../i18n";
import { confirmDialog } from "../dialogs/ConfirmDialog";
import { cardStyles } from "../_styles/receiptcard";
import { css } from "emotion";

declare type ContactBlockProps = {
    entry: any,
    onTopupByContact: (entry: any) => void,
    onDeleted?: () => void;
}
declare type ContactBlockState = {
    isDeleted: boolean;
}

export default class ContactBlock extends React.Component<ContactBlockProps, ContactBlockState> {
    readonly state: ContactBlockState = { isDeleted: false };
    topupByContact = () => {
        if (!this.props.onTopupByContact) return;
        this.props.onTopupByContact(this.props.entry);
    }
    deleteContact = async () => {
        const canCancel = await confirmDialog(t.myaccount("delete-contact-confirm-message"), t.menu("contact_list"), t.common("ok_button"), t.common("cancel_button"));
        if (canCancel.cancelled) {
            return;
        }
        dialogService.showPreloader();
        const response = MyAccountService.deletePhoneBookEntry(this.props.entry.phonebookId);
        await dialogService.hidePreloader();
        if (!response) return;
        this.setState({ isDeleted: true });
        if (this.props.onDeleted) this.props.onDeleted();
    }
    render() {
        if (this.state.isDeleted) return null;
        const book = this.props.entry;
        const url = `/images/countries/${book.country.countryCode}.png`;
        return <div className="form-group col-sm-6">
            <div className={classNames(["receipt-card", css(cardStyles.white)])}>
                <div className="d-flex align-items-center justify-content-between">
                    <div style={{ lineHeight: 1.3 }}>
                        <div>
                            <i className="fa fa-user" />
                            <span style={{ marginLeft: 5 }}>{book.name.length > 30 ? book.name.substring(0, 27) + "..." : book.name}</span>
                        </div>
                        <div className="font-weight-500">+{book.country.internationalCode} {book.mobileNumber}</div>
                        <div>
                            <span style={{ display: "inline-block", width: 24, height: 17, marginRight: 5, backgroundImage: `url(${url})`, verticalAlign: "text-bottom" }} />
                            <span>{book.product.name}</span>
                        </div>
                    </div>
                    <div>
                        <a href="javascript: void(0)" onClick={this.topupByContact}
                            className={classNames({ button: true })}>{t.common("top-up")}</a>
                    </div>
                </div>
                <hr />
                <div className="font-italic font-weight-500 d-flex align-items-center justify-content-end">
                    <Link to={`/contact/${book.phonebookId}`}>{t.common("edit")}</Link>
                    <React.Fragment>
                        <div style={{ width: 10 }} />
                        <a href="javascript:void(0)" onClick={this.deleteContact}>{t.common("remove")}</a>
                    </React.Fragment>
                </div>
            </div>
        </div>
    }
}